// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-calendar-close {
  display: flex;
  justify-content: end;
  gap: 5px;
  padding-bottom: 10px;
  cursor: pointer;
  color: rgb(0, 44, 93);
}

.custom-calendar-close-icon {
  font-size: 35px !important;
}

.custom-calendar-close-text {
  align-self: center;
  font-family: "Inter";
}

.custom-calendar * {
  font-family: "Inter";
}

.custom-calendar {
  font-family: "Inter";
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.custom-calendar-header {
  font-size: 20px;
  font-weight: 500;
  padding-bottom: 20px;
}

/* Calendar Navbar */
.cal-view-nav {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding-bottom: 20px;
  flex-wrap: wrap;
}

.cal-view-nav-left {
  display: flex;
  gap: 10px;
  align-items: center;
  font-family: "Inter";
}

.cal-view-nav-back-arrow {
  font-size: 20px !important;
  color: gray;
  cursor: pointer;
}

.cal-view-nav-forward-arrow {
  font-size: 20px !important;
  color: gray;
  cursor: pointer;
}

.cal-view-nav-today-btn {
  font-size: 14px;
  vertical-align: super;
  border: 0px;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
}

.cal-view-nav-center {
  font-size: 18px;
  display: flex;
  align-items: center;
}

.cal-view-nav-right {
  background-color: #f0f0f0;
  display: flex;
  gap: 12px;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  padding: 3px;
}

.cal-view-nav-right-content {
  padding: 6px;
  font-size: 14px;
}

.cal-view-nav-right-content-active {
  font-size: 14px;
  padding: 7px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.custom-calendar .rbc-month-row {
  overflow: visible; /* Hide overflow */
  min-height: 115px;
}

.custom-calendar .rbc-month-view {
  border-radius: 5px;
}

.custom-calendar .rbc-header {
  padding: 5px;
}

/* Indicators */
.indicator-div {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 0px;
}

.indicator-color {
  width: 40px;
  height: 25px;
  border-radius: 5px;
}

.indicator-name {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/views/panel/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB,EAAE,kBAAkB;EACrC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".custom-calendar-close {\n  display: flex;\n  justify-content: end;\n  gap: 5px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  color: rgb(0, 44, 93);\n}\n\n.custom-calendar-close-icon {\n  font-size: 35px !important;\n}\n\n.custom-calendar-close-text {\n  align-self: center;\n  font-family: \"Inter\";\n}\n\n.custom-calendar * {\n  font-family: \"Inter\";\n}\n\n.custom-calendar {\n  font-family: \"Inter\";\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.custom-calendar-header {\n  font-size: 20px;\n  font-weight: 500;\n  padding-bottom: 20px;\n}\n\n/* Calendar Navbar */\n.cal-view-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  padding-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.cal-view-nav-left {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-family: \"Inter\";\n}\n\n.cal-view-nav-back-arrow {\n  font-size: 20px !important;\n  color: gray;\n  cursor: pointer;\n}\n\n.cal-view-nav-forward-arrow {\n  font-size: 20px !important;\n  color: gray;\n  cursor: pointer;\n}\n\n.cal-view-nav-today-btn {\n  font-size: 14px;\n  vertical-align: super;\n  border: 0px;\n  padding: 8px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cal-view-nav-center {\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n}\n\n.cal-view-nav-right {\n  background-color: #f0f0f0;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 3px;\n}\n\n.cal-view-nav-right-content {\n  padding: 6px;\n  font-size: 14px;\n}\n\n.cal-view-nav-right-content-active {\n  font-size: 14px;\n  padding: 7px;\n  border-radius: 5px;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.custom-calendar .rbc-month-row {\n  overflow: visible; /* Hide overflow */\n  min-height: 115px;\n}\n\n.custom-calendar .rbc-month-view {\n  border-radius: 5px;\n}\n\n.custom-calendar .rbc-header {\n  padding: 5px;\n}\n\n/* Indicators */\n.indicator-div {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 0px;\n}\n\n.indicator-color {\n  width: 40px;\n  height: 25px;\n  border-radius: 5px;\n}\n\n.indicator-name {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
